import { useMutation } from '@hooks/reactQuery';

import { runProcessMoBranches, startProgress } from '@api/configurationComparison';

import { IMoBranchesDTO } from '@interfaces/cmModule/dto/cmModuleDTO';
import { ITreePreset } from '@interfaces/components/tree';

import { MO_BRANCHES_START_PROGRESS } from '@constants/queryKeys';

interface IUseMutateStartProgressProps {
	onSettledCallback: () => void;
	data: Partial<IMoBranchesDTO>;
	savedPreset?: ITreePreset;
}

export const useMutateStartProgress = (props: IUseMutateStartProgressProps) => {
	const { onSettledCallback, data, savedPreset } = props || {};
	const {
		data: progressId,
		mutate: runProgress,
	} = useMutation({
		mutationKey: [MO_BRANCHES_START_PROGRESS, data, savedPreset],
		mutationFn: startProgress,
		onSuccess: async (progressId: string) => {
			await runProcessMoBranches({ ...(savedPreset ? savedPreset : data), progressId });
			await onSettledCallback();
		},
	});

	return { runProgress, progressId };
};
